// extracted by mini-css-extract-plugin
export default {"text":"SubHeadingComponent_text__F4GeF"};